import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Entry Model
import VuexORM from '@vuex-orm/core';
import Vue from 'vue';
import Project from "./Project";
import Account from "./Account";
import User from "./User";
import Phase from "./Phase";
import Tag from 'src/store/models/Tag';
import EntryTag from 'src/store/models/EntryTag';
import Todo from 'src/store/models/Todo';
import moment from 'moment';

var _hash = require('object-hash');

var Entry = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Entry, _VuexORM$Model);

  var _super = _createSuper(Entry);

  function Entry() {
    _classCallCheck(this, Entry);

    return _super.apply(this, arguments);
  }

  _createClass(Entry, [{
    key: "$delete",
    value: function $delete() {
      return Entry.api().delete('/entries/' + this.entry_id, {
        delete: this.entry_id
      });
    }
  }], [{
    key: "fields",
    value: // This is the name used as module name of the Vuex Store.
    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        entry_id: this.attr(null),
        entry_date: this.attr(null),
        date: this.attr(null),
        project_id: this.attr(null),
        project: this.belongsTo(Project, 'project_id', 'project_id'),
        account: this.belongsTo(Account, 'account_id', 'account_id'),
        account_id: this.attr(null),
        user: this.belongsTo(User, 'user_id', 'user_id'),
        user_id: this.attr(null),
        task_id: this.attr(null),
        phase: this.belongsTo(Phase, 'task_id', 'task_id'),
        notes: this.attr(null),
        entry_minutes: this.attr(null),
        billed: this.number(0),
        locked: this.boolean(null),
        locked_by_date: this.attr(null),
        locked_by_apionly: this.attr(null),
        locked_by_membership: this.attr(null),
        locked_by_approval: this.attr(null),
        // client_id: this.attr(null), // deprecated column
        // client_name: this.attr(null), // deprecated column
        time_from: this.attr(null),
        time_to: this.attr(null),
        platform: this.attr(null),
        source: this.attr(null),
        source_id: this.attr(null),
        source_text: this.attr(null),
        source_url: this.attr(null),
        source_data: this.attr(null),
        todo_id: this.number(null).nullable(),
        todo: this.belongsTo(Todo, 'todo_id', 'todo_id'),
        tags: this.belongsToMany(Tag, EntryTag, 'entry_id', 'tag_id'),
        tag_ids: this.attr(null),
        hash: this.attr('')
      };
    }
  }, {
    key: "hash",
    value: function hash(entry) {
      return _hash({
        entry_id: entry.entry_id,
        entry_date: entry.entry_date,
        project_id: entry.project_id,
        billed: entry.billed,
        user_id: entry.user_id,
        group_id: entry.user.group_id,
        task_id: entry.task_id,
        notes: entry.notes,
        entry_minutes: entry.entry_minutes,
        client_id: entry.client_id,
        entry_time_from: entry.entry_time_from,
        entry_time_to: entry.entry_time_to,
        tags: entry.tags.map(function (tag) {
          return tag.tag_id;
        })
      });
    }
    /**
     * Hashes the entry for grouping purposes
     * @param {*} entry
     * @returns Hashed string of the entry
     */

  }, {
    key: "groupingHash",
    value: function groupingHash(entry) {
      return _hash({
        entry_date: entry.entry_date,
        project_id: entry.project_id,
        task_id: entry.task_id,
        billed: entry.billed,
        user_id: entry.user_id,
        notes: entry.notes,
        tags: entry.tags.map(function (tag) {
          return tag.tag_id;
        }),
        source: entry.source,
        source_id: entry.source_id,
        source_text: entry.source_text,
        source_url: entry.source_url,
        source_data: entry.source_data,
        todo_id: entry.todo_id,
        hourly_rate: entry.hourly_rate,
        hourly_cost: entry.hourly_cost
      });
    }
    /**
     * Check if the entry is editable.
     * @param {*} entry
     * @param {*} user
     */

  }, {
    key: "isEditable",
    value: function isEditable(entry, user) {
      var editable = false;
      var managedUserIds = user.managed_users_ids || [];

      if (!entry.locked_by_apionly && (entry.locked && user.is_admin || !entry.locked && (user.is_admin || managedUserIds.map(function (userId) {
        return parseInt(userId);
      }).includes(parseInt(entry.user_id)) || Project.$canEdit(entry.project_id, user.user_id) || entry.user_id === user.user_id))) {
        editable = true;
      }

      return editable;
    }
  }]);

  return Entry;
}(VuexORM.Model);

_defineProperty(Entry, "entity", 'entries');

_defineProperty(Entry, "primaryKey", 'entry_id');

_defineProperty(Entry, "state", {
  pending: false,
  lastSync: null
});

_defineProperty(Entry, "apiConfig", {
  actions: {
    fetch: function fetch(data) {
      return this.get('/entries/', data).then(function (result) {
        return result.response;
      });
    },
    store: function store(data) {
      var _this = this;

      if (data.time_from && !moment(data.time_from).isValid()) {
        delete data.time_from;
      }

      if (data.time_to && !moment(data.time_to).isValid()) {
        delete data.time_to;
      }

      return this.post('/entries', data).then(function (result) {
        Vue.prototype.$eventHub.$emit('entry-changed', result.response.data);

        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'entry_save', {}); // HUBSPOT

          window._hsq.push(['setPath', 'entry/save']);

          window._hsq.push(['trackPageView']);

          if (_this.$gtag) {
            _this.$gtag.event('entry_save', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        return result;
      });
    },
    update: function update(id, data) {
      if (data.time_from && !moment(data.time_from).isValid()) {
        delete data.time_from;
      }

      if (data.time_to && !moment(data.time_to).isValid()) {
        delete data.time_to;
      }

      return this.put('/entries/' + id, data).then(function (result) {
        Vue.prototype.$eventHub.$emit('entry-changed', result.response.data);
        return result;
      });
    },
    destroy: function destroy(id) {
      return this.delete('/entries/' + id, {
        delete: id
      }).then(function (result) {
        Vue.prototype.$eventHub.$emit('entry-changed', _objectSpread(_objectSpread({}, result.response.data), {}, {
          deleted: true
        }));
      });
    }
  }
});

export { Entry as default };